import { Box, Typography } from '@mui/material';
import type { TypographyProps } from '@mui/material';
import { useThemeProps } from '@mui/material/styles';
import { StatusDot } from '../StatusDot';

export type InfoPopoverItemProps = {
  label: string;
  value: string | number | null | undefined;
  fallback?: string;
  dotColor?: string;
};

export function InfoPopoverItem(inProps: InfoPopoverItemProps) {
  type ThemedItemProps = InfoPopoverItemProps & { bodyVariant?: TypographyProps['variant'] };
  const {
    bodyVariant,
    label,
    value,
    fallback = '-',
    dotColor,
  } = useThemeProps({
    props: inProps,
    name: 'InfoPopover',
  }) as ThemedItemProps;

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={1}
      py={0.5}
      sx={{
        '&:not(:last-child)': {
          borderBottom: 1,
          borderColor: (theme) => theme.palette.divider,
        },
      }}
    >
      <Typography variant={bodyVariant}>{label}</Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        {dotColor && <StatusDot color={dotColor} />}
        <Typography variant={bodyVariant}>{value ?? fallback}</Typography>
      </Box>
    </Box>
  );
}
